import React from 'react';
import { Box, Flex, Text, Image, Button, Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';

const TradeConfirmationModal = ({ isOpen, onCancel, onConfirm, item }) => {
  if (!item) return null;

  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.9)" />
      <ModalContent maxW="300px" background="transparent">
        <ModalBody p="20px">
          <Flex direction="column" align="center" gap="20px">
            <Box
              width="100px"
              height="100px"
              borderRadius="8px"
              overflow="hidden"
              backgroundImage={`url(${item.image})`}
              backgroundPosition="center"
              backgroundSize="cover"
            />
            <Flex flexDirection="column" gap="8px">
              <Text
                fontWeight="800"
                fontSize="24px"
                color="white"
                lineHeight="1.25"
                fontFamily="Manrope"
                textAlign="center"
              >
                Confirm Trade?
              </Text>

              <Text
                fontSize="14px"
                fontWeight="600"
                textAlign="center"
                lineHeight="1.3"
                color="rgba(255, 255, 255, 0.8)"
              >
                {`We’ll take ${item.coins_value} coins and send you to a form to fill in size and shipping`}
              </Text>
            </Flex>

            <Flex w="100%" gap="10px" mt="10px" flexDirection="column">
              <Button h="40px" variant="blue" w="100%" onClick={onConfirm}>
                CONFIRM
              </Button>
              <Button w="100%" h="40px" variant="outline" border="none" color="white" onClick={onCancel}>
                CANCEL
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TradeConfirmationModal;
